/**
 * Pass through transactions that our plugins don't care about.
 * @param {object} tr transaction
 * @param {object} [oldState]
 * @returns {object} state
 */
export function passThroughTransaction (tr, oldState) {
  return oldState ? oldState.map(tr.mapping, tr.doc) : oldState;
}
